import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrivateLibraryService {

  public contentType = new Subject();

  constructor(private _apiService: ApiService) { }

  getContent(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}`
    return this._apiService.get(url, data)
  }

  getCollabContent(fetchContentFor) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.COLLABORATIONS}/${fetchContentFor}`
    return this._apiService.get(url);
  }

  // getOtherUsersCollabContent() {
  //   const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.COLLABORATIONS}${API_ENDPOINTS.API.OTHER_USERS_COLLAB_CONTENT}`
  //   return this._apiService.get(url);
  // }

  showPackage(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}/${data}`
    return this._apiService.get(url)
  }

  deletePackage(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PACKAGES}/${data}`
    return this._apiService.delete(url)
  }

  // getAudioContentPlaylist(data) {
  //   const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}`
  //   return this._apiService.get(url, data)
  // }

  deleteContent(content_id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/${content_id}`
    return this._apiService.delete(url)
  }

  removeContent(content_id, type, force) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/${content_id}${API_ENDPOINTS.API.REMOVE}` + '?library_type=' + type + '&force=' + force;
    return this._apiService.get(url)
  }

  updateContent(content_id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/${content_id}`
    return this._apiService.put(url)
  }
  updateContentADP(obj) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.OUTLETS_INDIVIDUAL_CUSTOMER}${API_ENDPOINTS.API.REMOVE_CONTENT_FROM_SPECIFIC_OUTLET}`
    return this._apiService.put(url,obj)
  }

  shareContent(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTET_OPERATIONS}${API_ENDPOINTS.API.SHARE}`
    return this._apiService.put(url, params)
  }

  shareCollection(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}${API_ENDPOINTS.API.SHARE}`;
    return this._apiService.put(url, params);
  }

  getGifedContent() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}${API_ENDPOINTS.API.LIST_SENT_CONTENT}`;
    return this._apiService.get(url)
  }

  getExpiredContent() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}`;
    return this._apiService.get(url)
  }

  getGifedContentDetails(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}${API_ENDPOINTS.API.LIST_SENT_GIFT}` + "?" + params;
    return this._apiService.get(url)
  }

  saveToPrivateLibrary(id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PURCHASE_COLLECTION}/${id}`;
    return this._apiService.post(url);
  }

  publishToPrivateLibrary(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.WIPOD_PUBLISH_TO_PRIVATE}`;
    return this._apiService.put(url, data);
  }

  saveGiftToPrivateLibrary(id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}/${id}${API_ENDPOINTS.API.GIFT_SAVE_TO_PRIVATE}`;
    return this._apiService.put(url);
  }
}
